import { Headers } from '@egw/components'
import { CompanionAccountHoldingsDetails } from '@egw/features-holdings'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'

export const InvestmentsCompanionAccountHoldingDetailsPage: FC = () => {
  const { t } = useTranslation()

  return (
    <Layout>
      <Headers title={t('pages.investment.title')} />
      <CompanionAccountHoldingsDetails />
    </Layout>
  )
}
